import { render, staticRenderFns } from "./RatioForm.vue?vue&type=template&id=441582cb&scoped=true"
import script from "./RatioForm.vue?vue&type=script&lang=js"
export * from "./RatioForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441582cb",
  null
  
)

export default component.exports